<div class="card shadow-none bg-white border-bottom-lg animate__animated animated--fade-in">
	<div class="card-header">
		<div class="d-flex justify-content-between align-items-center g-3">
			<div class="electronic-process-tabs-wrapper">
				<div class="electronic-process-tabs">
					@if (!includeDocument) {
						<button type="button" class="electronic-process-tabs__button" [class.is-active]="activeTab === 'details'" (click)="setTab('details')">
							Detalhes
						</button>
					}
					<button
						type="button"
						class="electronic-process-tabs__button"
						[class.is-active]="activeTab === 'documents'"
						[disabled]="!canOpenDocumentsTab && !includeDocument"
						(click)="setTab('documents')">
						Documentos
						@if (loading || prefillingDemandDocuments) {
							<span class="badge rounded-pill text-bg-light ms-2">
								<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							</span>
						} @else {
							<span class="badge rounded-pill text-bg-light ms-2">{{ documentsForm.length }}</span>
						}
					</button>
					@if (process?.id && !includeDocument) {
						<button type="button" class="electronic-process-tabs__button" [class.is-active]="activeTab === 'book'" (click)="setTab('book')">
							Livro eletrônico
						</button>
						<button type="button" class="electronic-process-tabs__button" [class.is-active]="activeTab === 'pagination'" (click)="setTab('pagination')">
							Paginação
							@if (paginationProgress) {
								<span class="badge rounded-pill text-bg-light ms-2">
									<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
								</span>
							}
						</button>
					}
				</div>
			</div>
			<div class="d-flex justify-content-end w-25">
				@if (!isCreateMode) {
					<span class="badge rounded-pill align-self-center me-3" [class]="statusBadge(process?.status)">
						Status
						<b>{{ statusLabel(process?.status) }}</b>
					</span>
				}

				@if (process?.id && !includeDocument) {
					@if (downloadingAllAttachments) {
						<div class="d-flex justify-content-center">
							<app-pre-loading [inline]="true" [showMessage]="false" [large]="false"></app-pre-loading>
						</div>
					} @else {
						@if (processBusy) {
							<div class="d-flex justify-content-center">
								<app-pre-loading [inline]="true" [showMessage]="false" [large]="false"></app-pre-loading>
							</div>
						} @else {
							<div class="dropdown no-caret" ngbDropdown container="body">
								<a
									class="btn btn-icon btn-transparent-dark dropdown-toggle"
									ngbDropdownToggle
									data-cy="actions"
									role="button"
									aria-haspopup="true"
									aria-expanded="false">
									<fa-icon class="text-dark" icon="ellipsis-vertical"></fa-icon>
								</a>

								<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="actions">
									@if (process?.status === ElectronicProcessStatus.CREATED) {
										<button *permissions="'planning.electronic-process.manage'" class="dropdown-item" [disabled]="processBusy" (click)="publishProcess()">
											<div class="dropdown-item-icon"><fa-icon icon="paper-plane"></fa-icon></div>
											Publicar
										</button>
										<button *permissions="'planning.electronic-process.cancel'" class="dropdown-item" [disabled]="processBusy" (click)="cancelProcess()">
											<div class="dropdown-item-icon"><fa-icon icon="times-circle"></fa-icon></div>
											Cancelar
										</button>
									}

									<button *permissions="'planning.electronic-process.delete'" class="dropdown-item" [disabled]="processBusy" (click)="deleteProcess()">
										<div class="dropdown-item-icon"><fa-icon icon="trash"></fa-icon></div>
										Deletar
									</button>

									@if (canReprocessPagination) {
										<button *permissions="'planning.electronic-process.manage'" class="dropdown-item" [disabled]="processBusy" (click)="reprocessDocumentPagination()">
											<div class="dropdown-item-icon"><fa-icon icon="rotate-right"></fa-icon></div>
											{{ process?.status === ElectronicProcessStatus.PUBLISHED ? 'Reprocessar paginação' : 'Publicar novamente' }}
										</button>
									}

									@if (pendingSimulation) {
										<button *permissions="'planning.electronic-process.manage'" class="dropdown-item" [disabled]="processBusy" (click)="openSimulation(pendingSimulation)">
											<div class="dropdown-item-icon"><fa-icon icon="list-check"></fa-icon></div>
											Revisar simulação de renumeração
										</button>
									}

									<div class="dropdown-divider"></div>

									<button class="dropdown-item" [disabled]="processBusy" (click)="setTab('book')">
										<div class="dropdown-item-icon"><fa-icon icon="book-open"></fa-icon></div>
										Livro eletrônico
									</button>

									<button class="dropdown-item" [disabled]="processBusy || !canDownloadAllAttachments" (click)="downloadAllAttachmentsZip()">
										<div class="dropdown-item-icon"><fa-icon icon="download"></fa-icon></div>
										{{ downloadingAllAttachments ? 'Baixando documentos...' : 'Baixar todos os documentos (.zip)' }}
									</button>
								</div>
							</div>
						}
					}
				}
			</div>
		</div>
	</div>

	@if (process?.id) {
		<div class="electronic-process-pagination-notices">
			@if (paginationProgress; as run) {
				<div class="alert alert-info d-flex flex-wrap align-items-center gap-3 mb-0 rounded-0 border-0 border-bottom">
					<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
					<div class="flex-grow-1 min-w-0">
						<div class="fw-600">
							{{ run.typeLabel }} em andamento
							@if (run.type === PaginationRunType.INCLUDE) {
								<span class="fw-normal">· os documentos recebem folhas a partir da última</span>
							}
							@if (run.type === PaginationRunType.SIMULATION) {
								<span class="fw-normal">· nada muda até você aplicar; o processo segue publicado</span>
							}
						</div>
						<div class="small">{{ run.progressLabel }}</div>
						<div class="progress mt-1" style="height: 4px" role="progressbar" [attr.aria-valuenow]="run.percent" aria-valuemin="0" aria-valuemax="100">
							<div class="progress-bar" [style.width.%]="run.percent || 5"></div>
						</div>
					</div>
					@if (run.type === PaginationRunType.SIMULATION) {
						<button type="button" class="btn btn-sm btn-outline-primary" (click)="openSimulation(run)">Acompanhar</button>
					}
				</div>
			}

			@if (failedPublication; as run) {
				<div class="alert alert-danger mb-0 rounded-0 border-0 border-bottom">
					<div class="d-flex flex-wrap align-items-start gap-3">
						<fa-icon icon="circle-exclamation" class="mt-1"></fa-icon>
						<div class="flex-grow-1 min-w-0">
							<p class="fw-700 mb-1">A publicação falhou e nenhuma folha foi gravada.</p>
							<app-electronic-process-pagination-failures [failure]="run.error"></app-electronic-process-pagination-failures>
							<p class="small mt-2 mb-0">Corrija ou remova os documentos apontados e publique novamente.</p>
						</div>
						@if (canReprocessPagination) {
							<button *permissions="'planning.electronic-process.manage'" type="button" class="btn btn-sm btn-danger" [disabled]="processBusy" (click)="reprocessDocumentPagination()">
								Publicar novamente
							</button>
						}
					</div>
				</div>
			}

			@if (process?.paginationOutdated) {
				<div class="alert alert-warning d-flex flex-wrap align-items-center gap-3 mb-0 rounded-0 border-0 border-bottom">
					<fa-icon icon="exclamation-triangle"></fa-icon>
					<div class="flex-grow-1 min-w-0">
						<p class="fw-700 mb-0">Paginação desatualizada — reprocesse</p>
						<p class="small mb-0">
							A ordem, o arquivo principal ou os anexos de um documento mudaram depois da paginação. Até o reprocessamento ser aplicado, o livro
							eletrônico fica bloqueado, os documentos incluídos aguardam e o portal segue com a paginação anterior.
						</p>
					</div>
					@if (canReprocessPagination) {
						<button *permissions="'planning.electronic-process.manage'" type="button" class="btn btn-sm btn-warning" [disabled]="processBusy" (click)="reprocessDocumentPagination()">
							Reprocessar paginação
						</button>
					}
				</div>
			}

			@if (pendingSimulation; as run) {
				<div class="alert alert-warning d-flex flex-wrap align-items-center gap-3 mb-0 rounded-0 border-0 border-bottom">
					<fa-icon icon="list-check"></fa-icon>
					<div class="flex-grow-1 min-w-0">
						<p class="fw-700 mb-0">Simulação de renumeração pronta para revisão</p>
						<p class="small mb-0">
							{{ run.changes?.length ?? 0 }} arquivo(s) mudam de folha ({{ run.pagesBefore ?? 0 }} → {{ run.pagesAfter ?? 0 }} folhas)
							@if (run.expiresAt) {
								· pode ser aplicada até {{ run.expiresAt | date: "dd/MM/yyyy 'às' HH:mm" }}
							}
						</p>
					</div>
					<button *permissions="'planning.electronic-process.manage'" type="button" class="btn btn-sm btn-primary" (click)="openSimulation(run)">
						Revisar e aplicar
					</button>
				</div>
			}
		</div>
	}

	@if (activeTab === 'book' && !includeDocument && process?.id) {
		<div class="card-body">
			<app-electronic-process-books [processId]="process?.id" [processNumber]="process?.externalCode"></app-electronic-process-books>
		</div>
	} @else if (activeTab === 'pagination' && !includeDocument && process?.id) {
		<div class="card-body">
			<app-electronic-process-pagination-history [processId]="process?.id" (review)="openSimulation($event)"></app-electronic-process-pagination-history>
		</div>
	} @else if (activeTab === 'details' && !includeDocument) {
		<div class="card-body" [formGroup]="form">
			<div class="row g-3">
				<div class="col-md-3">
					<label class="form-label">Planejamento</label>
					<ng-select
						class="ng-custom-select xl"
						bindLabel="externalCode"
						[addTag]="true"
						[clearable]="!lockDemandAndUnit"
						[maxSelectedItems]="1"
						[readonly]="isReadonly || lockDemandAndUnit"
						loadingText="Aguarde..."
						[(ngModel)]="linkedDemand"
						[loading]="detailsInputsLoading"
						placeholder="Busque por protocolo DID"
						[items]="linkedDemandIntentDocuments"
						[ngModelOptions]="{ standalone: true }"
						(search)="onLinkedDemandSearch($event.term)"
						(ngModelChange)="onLinkedDemandChange($event)"
						[notFoundText]="'Nenhum registro encontrado'"
						[addTagText]="'Enter para pesquisar o número do DID'"
						[class.is-invalid]="demandIntentDocumentControlInvalid">
						<ng-template ng-option-tmp let-item="item">
							<div class="small fw-700">{{ item.externalCode }}</div>
							<div class="small text-muted text-wrap">{{ item.object }}</div>
						</ng-template>
						<ng-template ng-label-tmp let-item="item">
							{{ item.externalCode }}
						</ng-template>
					</ng-select>
					@if (demandIntentDocumentControl.hasError('required')) {
						<div class="invalid-feedback">Informe o planejamento</div>
					}
					@if (prefillingDemandDocuments) {
						<div class="mt-2">
							<app-pre-loading [inline]="true" [large]="false" msg="Buscando documentos assinados do planejamento"></app-pre-loading>
						</div>
					}
				</div>

				<div class="col-md-6">
					<label class="form-label">Unidade</label>
					<ng-select
						class="ng-custom-select xl"
						[items]="units"
						bindLabel="name"
						bindValue="id"
						[clearable]="true"
						[loading]="detailsInputsLoading"
						[readonly]="isReadonly || lockDemandAndUnit"
						formControlName="unitId"
						placeholder="Selecione a unidade"
						[class.is-invalid]="unitControlInvalid"></ng-select>
					@if (unitControl.hasError('required')) {
						<div class="invalid-feedback">Informe a unidade</div>
					}
				</div>

				<div class="col-md-3">
					<label class="form-label">Número</label>
					<div class="position-relative">
						<input
							class="form-control form-control-lg"
							type="text"
							[readonly]="isReadonly || detailsInputsLoading"
							[placeholder]="detailsInputsLoading ? 'Carregando dados do processo...' : 'Número processo'"
							formControlName="externalCode"
							[class.is-invalid]="externalCodeControlInvalid" />
						@if (detailsInputsLoading) {
							<div class="position-absolute top-50 end-0 translate-middle-y me-3 text-muted">
								<span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
							</div>
						}
					</div>
					@if (externalCodeControl.hasError('required')) {
						<div class="invalid-feedback">Informe a unidade</div>
					}
				</div>

				<div class="col-md-12">
					<label class="form-label">Objeto</label>
					<textarea
						class="form-control"
						rows="6"
						[readonly]="isReadonly || detailsInputsLoading"
						formControlName="object"
						[placeholder]="detailsInputsLoading ? 'Carregando dados do processo...' : 'Descreva o objeto do processo'"
						[class.is-invalid]="objectControlInvalid"></textarea>
					@if (objectControl.hasError('required')) {
						<div class="invalid-feedback">Informe o objeto</div>
					}
				</div>
			</div>
		</div>
		<div class="card-footer">
			<div class="d-flex flex-wrap gap-2 justify-content-end">
				@if (canEditProcess && (activeTab === 'details' || isCreateMode)) {
					<button class="btn btn-primary fw-700" type="button" [disabled]="processBusy || prefillingDemandDocuments" (click)="handlePrimaryAction()">
						{{ processBusy ? 'Salvando...' : primaryActionLabel }}
					</button>
				}
			</div>
		</div>
	} @else {
		@if (showIncludeProcessSelection) {
			<div class="card-header">
				<h5 class="mb-0">Selecionar processo eletrônico</h5>
			</div>
			<div class="card-body">
				<div class="row g-3">
					<div class="col-md-12">
						<label class="form-label">Buscar processo eletrônico</label>
						<div class="input-group">
							<input
								class="form-control"
								type="text"
								placeholder="Número do processo eletrônico"
								[readonly]="loading || includeModeProcessesLoading"
								[(ngModel)]="includeModeProcessTerm"
								[ngModelOptions]="{ standalone: true }"
								(keyup.enter)="onIncludeModeProcessSearch(includeModeProcessTerm)" />
							<button
								class="btn btn-primary"
								type="button"
								[disabled]="loading || includeModeProcessesLoading"
								(click)="onIncludeModeProcessSearch(includeModeProcessTerm)">
								Buscar
							</button>
						</div>
					</div>
					<div class="col-md-12">
						@if (loading || includeModeProcessesLoading) {
							<app-pre-loading></app-pre-loading>
						} @else if (includeModeProcesses.length === 0) {
							<app-empty-data message="Nenhum processo eletrônico criado encontrado." class="p-5"></app-empty-data>
						} @else {
							<div class="list-group">
								@for (item of includeModeProcesses; track item.id) {
									<button type="button" class="list-group-item list-group-item-action text-start" (click)="selectIncludeModeProcess(item)">
										<div class="fw-700">{{ item.externalCode }}</div>
										<div class="small text-muted">{{ item.object || 'Objeto não informado' }}</div>
									</button>
								}
							</div>

							@if (includeModeProcessPage && !includeModeProcessPage.empty) {
								<div class="d-flex justify-content-end mt-3">
									<ngb-pagination
										[rotate]="true"
										[maxSize]="5"
										[pageSize]="includeModeProcessPage.size"
										[page]="includeModeProcessPage.page + 1"
										[collectionSize]="includeModeProcessPage.totalElements"
										(pageChange)="onIncludeModeProcessPageChange($event - 1)"></ngb-pagination>
								</div>
							}
						}
					</div>
				</div>
			</div>
		} @else if (createDocument) {
			<div class="card-header">
				<h5 class="mb-0">Incluir documento</h5>
			</div>
			<div class="card-body" [formGroup]="documentForm">
				<div class="row g-3">
					<div class="col-md-12">
						<label class="form-label">Titulo</label>
						<input class="form-control form-control-lg" type="text" formControlName="title" [class.is-invalid]="documentTitleControlInvalid" />
						@if (documentTitleControl.hasError('required')) {
							<div class="invalid-feedback">Informe o titulo</div>
						}
					</div>
					<div class="col-md-4">
						<label class="form-label">Tipo de origem</label>
						<ng-select
							class="ng-custom-select xl"
							bindLabel="label"
							bindValue="value"
							[clearable]="false"
							formControlName="sourceType"
							[items]="sourceTypeOptions"
							[class.is-invalid]="documentSourceTypeControlInvalid"></ng-select>
						@if (documentSourceTypeControl.hasError('required')) {
							<div class="invalid-feedback">Informe o tipo de origem</div>
						}
					</div>
					<div class="col-md-4">
						<label class="form-label">Visibilidade</label>
						<ng-select
							class="ng-custom-select xl"
							bindLabel="label"
							bindValue="value"
							[items]="visibleTypeOptions"
							formControlName="visibleType"
							[class.is-invalid]="documentVisibleTypeControlInvalid"></ng-select>
						@if (documentVisibleTypeControl.hasError('required')) {
							<div class="invalid-feedback">Informe a visibilidade</div>
						}
					</div>
					<div class="col-md-4">
						<label class="form-label">Data</label>
						<input
							class="form-control form-control-lg"
							[owlDateTime]="date"
							placeholder="dd/mm/yyyy"
							formControlName="date"
							[owlDateTimeTrigger]="date"
							[class.is-invalid]="documentDateControlInvalid" />
						<owl-date-time #date [pickerType]="'calendar'"></owl-date-time>
						@if (documentDateControl.hasError('required')) {
							<div class="invalid-feedback">Informe a data</div>
						}
					</div>
					<div class="col-md-12">
						<label class="form-label">Anexo (PDF, máximo 20MB)</label>
						<input
							class="form-control form-control-lg"
							type="file"
							accept="application/pdf,.pdf"
							[disabled]="creatingDocument"
							[class.is-invalid]="documentOtherFileControlInvalid"
							(change)="onOtherDocumentFileSelected($event)" />
						@if (documentOtherFileControl.hasError('required')) {
							<div class="invalid-feedback">Informe um anexo em PDF</div>
						}
					</div>
					<div class="col-md-12">
						<label class="form-label">Descrição (opcional)</label>
						<textarea class="form-control form-control-lg" formControlName="description"></textarea>
					</div>
					<div class="col-md-12 d-flex justify-content-end">
						<button *permissions="'planning.electronic-process.update'" class="btn btn-link text-danger ms-3" (click)="createDocument = false">Cancelar</button>
						<button *permissions="'planning.electronic-process.update'" class="btn btn-primary fw-600" type="button" [disabled]="creatingDocument" (click)="addDocument()">
							{{ creatingDocument ? 'Incluindo...' : 'Incluir documento' }}
						</button>
					</div>
				</div>
			</div>
		} @else {
			<div class="card-header d-flex justify-content-between align-items-center gap-2 flex-wrap">
				<h5 class="mb-0">Documentos do processo</h5>
				<div>
					@if (canAddDocuments && isActiveAddDocuments) {
						<button *permissions="'planning.electronic-process.update'" class="btn btn-sm btn-icon text-bg-primary" type="button" [disabled]="submittingDocuments" (click)="addNewDocument()">
							<fa-icon icon="plus"></fa-icon>
						</button>
					}
				</div>
			</div>
			<div class="card-body">
				@if (loading || prefillingDemandDocuments) {
					<app-pre-loading></app-pre-loading>
				} @else if (documentsForm.length === 0) {
					<app-empty-data message="Nenhum documento vinculado a este processo." class="py-4"></app-empty-data>
				} @else {
					<div class="electronic-process-documents">
						@for (documentControl of documentsForm.controls; track trackByDocument($index); let i = $index) {
							<div
								#documentItem
								class="electronic-process-documents__item"
								[attr.data-document-index]="i"
								[class.is-moving-from]="movingDocumentFromIndex === i"
								[class.is-moving-to]="movingDocumentToIndex === i"
								[class.is-moving-up]="movingDocumentToIndex === i && movingDocumentDirection === -1"
								[class.is-moving-down]="movingDocumentToIndex === i && movingDocumentDirection === 1"
								[class.is-drag-arming]="dragPressIndex === i"
								[class.is-drag-active]="dragActiveIndex === i"
								[formGroup]="$any(documentControl)">
								<div class="row g-3 align-items-center">
									<div class="col-md-1 d-flex flex-column justify-content-center align-items-center">
										<button
											class="btn btn-sm btn-icon fw-700 p-2 mb-2"
											[ngbTooltip]="'Status atual ' + documentStatusLabel(documentControl.get('status')?.value)"
											[ngClass]="documentStatusBadge(documentControl.get('status')?.value)">
											{{ documentControl.get('ordering').value }}
										</button>
										@if (canReorderDocuments) {
											<button
												type="button"
												class="electronic-process-documents__drag-handle"
												[class.is-arming]="dragPressIndex === i"
												[class.is-active]="dragActiveIndex === i"
												[class.is-loading]="submittingDocuments && savingDocumentMoveIndex === i"
												[disabled]="submittingDocuments"
												[attr.aria-busy]="submittingDocuments && savingDocumentMoveIndex === i"
												(pointerdown)="startDocumentDragPress($event, i)"
												(pointermove)="onDocumentDragPointerMove($event)"
												(pointerup)="finishDocumentDragPress($event)"
												(pointercancel)="finishDocumentDragPress($event)"
												(lostpointercapture)="finishDocumentDragPress()">
												@if (submittingDocuments && savingDocumentMoveIndex === i) {
													<span
														class="spinner-border spinner-border-sm electronic-process-documents__drag-spinner"
														aria-hidden="true"></span>
													<span class="electronic-process-documents__drag-label">Salvando</span>
												} @else {
													<span class="electronic-process-documents__drag-grip" aria-hidden="true"></span>
													@if (dragActiveIndex === i) {
														<span class="electronic-process-documents__drag-label">Mudando</span>
													} @else {
														<span class="electronic-process-documents__drag-label">Segure {{ delayTapMoveMs / 1000 }}s</span>
													}
												}
											</button>
										}
									</div>
									<div class="col-md-10">
										<div class="row">
											<div class="col-md-12">
												<div class="row">
													<div class="col-md-12 mb-2">
														<div class="form-floating">
															<input
																class="form-control"
																type="text"
																placeholder="Titulo"
																formControlName="title"
																[readonly]="!canEditDocumentRow(documentControl)"
																[class.is-invalid]="documentControl.get('title').hasError('required')" />
															<label class="form-label">Titulo</label>
														</div>
													</div>
													<div class="col-md-12 mb-2">
														<div class="form-floating">
															<input
																class="form-control"
																type="text"
																placeholder="Descrição (opcional)"
																formControlName="description"
																[readonly]="!canEditDocumentRow(documentControl)" />
															<label class="form-label">Descrição (opcional)</label>
														</div>
													</div>
												</div>
											</div>
											<div class="col-md-12">
												<div class="row">
													<div class="col-md-6 mb-2">
														<div class="form-floating">
															<input
																class="form-control"
																type="text"
																formControlName="date"
																[owlDateTime]="date"
																placeholder="dd/mm/yyyy"
																[owlDateTimeTrigger]="date"
																[readonly]="!canEditDocumentRow(documentControl)"
																[class.is-invalid]="documentControl.get('date').hasError('required')" />
															<owl-date-time #date [pickerType]="'calendar'"></owl-date-time>
															<label class="form-label">Data</label>
														</div>
													</div>
													<div class="col-md-6 mb-2">
														<ng-select
															class="ng-custom-select xl ng-floating"
															placeholder="Visibilidade"
															bindLabel="label"
															bindValue="value"
															[clearable]="false"
															[items]="visibleTypeOptions"
															formControlName="visibleType"
															[readonly]="!canEditDocumentVisibleType(documentControl)"
															[class.is-invalid]="documentControl.get('visibleType').hasError('required')"></ng-select>
													</div>
													@if (isOtherDocument($any(documentControl)) && getDocumentAttachments($any(documentControl)).length > 0) {
														<div class="col-md-12 mb-2">
															<div class="border rounded p-2 bg-white">
																@for (attachment of getDocumentAttachments($any(documentControl)); track attachment.id) {
																	<div class="d-flex justify-content-between align-items-center gap-2">
																		<div class="small fw-700 text-muted text-uppercase">
																			{{ attachment.name || attachment.filename || 'Anexo' }}
																			<app-file-size-badge [bytes]="attachment.size"></app-file-size-badge>
																		</div>
																		<button
																			class="btn btn-sm btn-icon"
																			type="button"
																			[disabled]="documentControl.get('submitting').value"
																			(click)="downloadDocumentAttachment($any(documentControl), attachment)">
																			<fa-icon icon="download"></fa-icon>
																		</button>
																	</div>
																}
															</div>
														</div>
													}
												</div>
											</div>
										</div>
									</div>
									<div class="col-md-1">
										<div class="electronic-process-documents__actions d-flex justify-content-center align-items-center gap-2 flex-wrap">
											@if (canReorderDocuments) {
												<div class="btn-group me-2" style="height: 32px">
													<button *permissions="'planning.electronic-process.update'"
														class="btn btn-primary"
														type="button"
														[disabled]="submittingDocuments || i === 0"
														(click)="moveDocument(i, -1)">
														<fa-icon icon="arrow-up"></fa-icon>
													</button>
													<button *permissions="'planning.electronic-process.update'"
														class="btn btn-primary"
														type="button"
														[disabled]="submittingDocuments || i === documentsForm.length - 1"
														(click)="moveDocument(i, 1)">
														<fa-icon icon="arrow-down"></fa-icon>
													</button>
												</div>
											}

											@if (documentControl.get('submitting').value) {
												<div class="d-flex justify-content-center align-items-center p-2">
													<app-pre-loading [large]="false" [inline]="true" [showMessage]="false"></app-pre-loading>
												</div>
											} @else {
												<div class="dropdown no-caret" ngbDropdown container="body">
													<a
														class="btn btn-icon btn-transparent-dark dropdown-toggle"
														ngbDropdownToggle
														data-cy="actions"
														role="button"
														aria-haspopup="true"
														aria-expanded="false">
														<fa-icon class="text-dark" icon="ellipsis-vertical"></fa-icon>
													</a>

													<div class="dropdown-menu border-0 shadow animated--fade-in-up" ngbDropdownMenu aria-labelledby="actions">
														<button class="dropdown-item" (click)="downloadDocument($any(documentControl))">
															<div class="dropdown-item-icon">
																<fa-icon icon="download"></fa-icon>
															</div>
															Baixar documento
														</button>
														@if (
															canManageDocuments && documentControl.get('id')?.value && documentControl.get('status')?.value !== 2
														) {
															<button *permissions="'planning.electronic-process.update'" class="dropdown-item" (click)="cancelDocument($any(documentControl))">
																<div class="dropdown-item-icon">
																	<fa-icon icon="times"></fa-icon>
																</div>
																Cancelar
															</button>
														}

														@if (canRetryDocumentPagination(documentControl)) {
															<button *permissions="'planning.electronic-process.update'" class="dropdown-item" (click)="retryDocumentPagination($any(documentControl))">
																<div class="dropdown-item-icon">
																	<fa-icon icon="rotate-right"></fa-icon>
																</div>
																Tentar paginar novamente
															</button>
														}

														@if (canRemoveDocument(documentControl)) {
															<button *permissions="'planning.electronic-process.update'" class="dropdown-item" (click)="removeDocument(i, $any(documentControl))">
																<div class="dropdown-item-icon">
																	<fa-icon icon="trash"></fa-icon>
																</div>
																{{ canEditDocumentList ? 'Deletar' : 'Remover documento' }}
															</button>
														}
													</div>
												</div>
											}
										</div>
									</div>

									@if (documentPagination(documentControl)?.paginationState; as state) {
										<div class="col-md-12 d-flex flex-wrap align-items-center gap-2">
											<span class="badge rounded-pill" [ngClass]="'text-bg-' + state.tone">
												@if (state.tone === 'info') {
													<span class="spinner-border spinner-border-sm me-1" style="width: 0.7rem; height: 0.7rem" aria-hidden="true"></span>
												}
												{{ state.label }}
											</span>
											@if (documentPagination(documentControl)?.paginationFailureReason; as reason) {
												<small class="text-danger">{{ reason }}</small>
											}
										</div>
									}

									@if (documentControl.get('hasPage')?.value) {
										<div class="col-md-12">
											<small>
												Da página {{ documentControl.get('page').value?.ini }} até
												{{ (documentControl.get('page').value?.end ?? 0) + getDocumentAttachmentPagesTotal($any(documentControl)) }} com
												um total de
												{{
													(documentControl.get('page').value?.total ?? 0) + getDocumentAttachmentPagesTotal($any(documentControl))
												}}
												página(s)
											</small>
										</div>
									}
								</div>
							</div>
						}
					</div>
				}
			</div>
			<div class="card-footer">
				<div class="d-flex flex-wrap gap-2 justify-content-end">
					@if (canEditProcess && isCreateMode) {
						<button class="btn btn-primary" type="button" [disabled]="processBusy" (click)="handlePrimaryAction()">
							{{ processBusy ? 'Salvando...' : primaryActionLabel }}
						</button>
					} @else if (includeDocument && includeDocumentRequest && documentsForm.length > 0) {
						<button *permissions="'planning.electronic-process.update'" class="btn btn-primary fw-700 ms-3" type="button" [disabled]="!canConfirmIncludeDocument" (click)="includeDocumentInProcess()">
							{{ creatingDocument ? 'Salvando inclusão...' : 'Salvar inclusão' }}
						</button>
					} @else if (canPersistDocumentChanges && documentsForm.length > 0) {
						<button *permissions="'planning.electronic-process.update'" class="btn btn-primary fw-700 ms-3" type="button" [disabled]="submittingDocuments" (click)="saveDocuments()">
							{{ submittingDocuments ? 'Salvando...' : 'Salvar alterações' }}
						</button>
					}
				</div>
			</div>
		}
	}
</div>

<ng-template #modalMergedDocument let-modal>
	<div class="modal-header">
		<div class="d-flex align-items-center justify-content-between w-100">
			<h4 class="modal-title">{{ mergedDocumentFilename || 'Documento único' }}</h4>
			<div class="d-flex align-items-center justify-content-start gap-2">
				<button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss()"></button>
			</div>
		</div>
	</div>
	<div class="modal-body p-0 overflow-hidden">
		@if (mergedDocumentUrl) {
			<iframe [src]="mergedDocumentUrl" width="100%" height="100%" [frameBorder]="0" style="min-height: calc(100vh - 64px)"></iframe>
		} @else {
			<div class="d-flex h-100 align-items-center justify-content-center">
				<app-empty-data message="Não foi possível visualizar o documento."></app-empty-data>
			</div>
		}
	</div>
</ng-template>
